<div class="row">

    <div class="col-md-9 px-lg-1">
        <div class="card">
            <div class="card-body p-0">
                <app-upcoming></app-upcoming>
                <!-- slider -->
                <div id="DashSliderCarousel" class="carousel slide" data-bs-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-bs-target="#DashSliderCarousel" data-bs-slide-to="0" class="active"></li>
                        <li data-bs-target="#DashSliderCarousel" data-bs-slide-to="1"></li>
                        <li data-bs-target="#DashSliderCarousel" data-bs-slide-to="2"></li>
                        <li data-bs-target="#DashSliderCarousel" data-bs-slide-to="3"></li>
                        <li data-bs-target="#DashSliderCarousel" data-bs-slide-to="4"></li>
                    </ol>
                    <div class="carousel-inner" role="listbox">
                        <div class="carousel-item" [ngClass]="{'active': i == 0}"  *ngFor="let item of topBanners;let i=index;trackBy:trackByIndex;">
                            <img class="d-block img-fluid" [src]="item" alt="">
                          </div>
                    </div>
                </div>
                <!-- slider -->

                <!-- eventlist -->
                <div class="row">
                    <div class="col-12">
                        <div class="eventlistdesign">
                            <!-- mobile -->
                            <!-- <ul class="nav nav-pills mobile_nav_pills">
                                <li class="nav-item">
                                    <a href="#Cricket" data-bs-toggle="tab" aria-expanded="false"
                                        class="nav-link active">
                                        <img class="img-fluid" src="assets/img/cricket.svg">
                                        Cricket
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#Soccer" data-bs-toggle="tab" aria-expanded="true" class="nav-link">
                                        <img class="img-fluid" src="assets/img/soccer.svg">
                                        Soccer
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#Tennis" data-bs-toggle="tab" aria-expanded="false" class="nav-link">
                                        <img class="img-fluid" src="assets/img/tennis.svg">
                                        Tennis
                                    </a>
                                </li>

                                <a class="mobile-search-btn" href="javascript:;">
                                    <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="m29.6697865 25.8286042h-1.0026615l-.3764635-.3143021c1.191151-1.4455833 1.9434479-3.2687188 1.9434479-5.342849-.0000573-4.5258698-3.6359011-8.1714531-8.14825-8.1714531-4.4505886 0-8.0858594 3.6455833-8.0858594 8.1714531s3.6352708 8.1713959 8.1483073 8.1713959c2.0058385 0 3.886151-.7543594 5.3276094-1.948375l.3758906.3143593v1.0055261l6.2678802 6.2856406 1.8803125-1.8856979zm-7.5214792 0c-3.1339688 0-5.6411094-2.5143594-5.6411094-5.6571511 0-3.1429062 2.5071406-5.6570937 5.6411094-5.6570937 3.1338542 0 5.6410521 2.5141875 5.6410521 5.6570937 0 3.1427917-2.5071979 5.6571511-5.6410521 5.6571511z"
                                            fill="rgb(255,255,255)" transform="translate(-14 -12)" />
                                    </svg>
                                </a>
                            </ul> -->
                            <!-- mobile -->
                            <h2 class="high-desktop"> &nbsp;&nbsp; highlights</h2>

                            <tabset type="pills navtab-bg desktop-nav-pills">
                                <tab *ngFor="let mn of menu; let i=index;trackBy:trackByIndex;"
                                    (selectTab)="onSelect(mn)">
                                    <ng-template tabHeading>
                                        <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/{{mn.id}}.svg">
                                        {{mn.name}}
                                    </ng-template>
                                    <!-- <a class="mobile-search-btn" href="javascript:;">
                                        <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="m29.6697865 25.8286042h-1.0026615l-.3764635-.3143021c1.191151-1.4455833 1.9434479-3.2687188 1.9434479-5.342849-.0000573-4.5258698-3.6359011-8.1714531-8.14825-8.1714531-4.4505886 0-8.0858594 3.6455833-8.0858594 8.1714531s3.6352708 8.1713959 8.1483073 8.1713959c2.0058385 0 3.886151-.7543594 5.3276094-1.948375l.3758906.3143593v1.0055261l6.2678802 6.2856406 1.8803125-1.8856979zm-7.5214792 0c-3.1339688 0-5.6411094-2.5143594-5.6411094-5.6571511 0-3.1429062 2.5071406-5.6570937 5.6411094-5.6570937 3.1338542 0 5.6410521 2.5141875 5.6410521 5.6570937 0 3.1427917-2.5071979 5.6571511-5.6410521 5.6571511z"
                                                fill="rgb(255,255,255)" transform="translate(-14 -12)" />
                                        </svg>
                                    </a> -->
                                    <h2 class="high-mobile"> &nbsp;&nbsp; highlights</h2>
                                    <!-- sports -->
                                    <div
                                        *ngIf="mn.id != '99999' && mn.id != '99995' && mn.id != '7' && mn.id != '4339'">
                                        <div class="row oneX2">
                                            <div class="col-md-6">
                                            </div>
                                            <div class="col-md-6 px-lg-0">
                                                <div class="oddsEventlist">
                                                    <div class="btn-group">
                                                        <span>1</span>
                                                    </div>
                                                    <div class="btn-group">
                                                        <span>X</span>
                                                    </div>
                                                    <div class="btn-group">
                                                        <span>2</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row align-items-center row-my"
                                            *ngFor="let item of mn.tabData;trackBy:trackByIndex;">
                                            <div class="col-md-4 px-1 col-9" (click)="detailPage(item)">
                                                <p class="matchname">
                                                    <a>{{(item.name) ? item.name : item.market_name}} </a>
                                                    <span>{{(item.open_date_format) ? (item.open_date_format | date :
                                                        'dd/MM/YYYY hh:mm a') :
                                                        item.market_start_time_format | date : 'dd/MM/YYYY hh:mm
                                                        a'}}</span>

                                                    <span class="in_play" *ngIf="item.in_play == 1">In-Play</span>
                                                    <span class="in_play"
                                                        *ngIf="item.tv_channel != '' && item.tv_channel != null"><i
                                                            class="mdi mdi-television"></i></span>
                                                </p>
                                            </div>
                                            <div class="col-md-2 col-3 text-right">
                                                <span class="game-fancy" *ngIf="item.fancy_active == 1">F</span>

                                                <span class="game-bm" *ngIf="item.bm_active == 1">BM</span>
                                                <span class="game-custom"
                                                    *ngIf="item?.custom_active && item?.custom_active != ''">{{item?.custom_active}}</span>
                                            </div>
                                            <div class="col-md-6 px-0 col-1">
                                                <div class="oddsEventlist">
                                                    <div class="btn-group">
                                                        <button
                                                            class="{{oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.key}} back">{{!(oddsLisDis[item?.market_id]
                                                            &&
                                                            oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                                (oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price)
                                                                ?
                                                                oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price
                                                                : '-' }} </button>
                                                                <button
                                                                    class="{{oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.key}} lay">{{!(oddsLisDis[item?.market_id]
                                                                    &&
                                                                    oddsLisDis[item?.market_id]?.numberOfRunners <= 3)
                                                                        ? '-' :
                                                                        (oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price)
                                                                        ?
                                                                        oddsLisDis[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price
                                                                        : '-' }}</button>
                                                    </div>
                                                    <div class="btn-group">
                                                        <button
                                                            class="{{oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.key}} back">{{!(oddsLisDis[item?.market_id]
                                                            &&
                                                            oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                                (oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price)
                                                                ?
                                                                oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price
                                                                : '-' }}</button>
                                                                <button
                                                                    class="{{oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.key}} lay">{{!(oddsLisDis[item?.market_id]
                                                                    &&
                                                                    oddsLisDis[item?.market_id]?.numberOfRunners <= 3)
                                                                        ? '-' :
                                                                        (oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price)
                                                                        ?
                                                                        oddsLisDis[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price
                                                                        : '-' }}</button>
                                                    </div>
                                                    <div class="btn-group">
                                                        <button
                                                            class="{{oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.key}} back">{{!(oddsLisDis[item?.market_id]
                                                            &&
                                                            oddsLisDis[item?.market_id]?.numberOfRunners <= 3) ? '-' :
                                                                (oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price)
                                                                ?
                                                                oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price
                                                                : '-' }}</button>
                                                                <button
                                                                    class="{{oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.key}} lay">{{!(oddsLisDis[item?.market_id]
                                                                    &&
                                                                    oddsLisDis[item?.market_id]?.numberOfRunners <= 3)
                                                                        ? '-' :
                                                                        (oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price)
                                                                        ?
                                                                        oddsLisDis[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price
                                                                        : '-' }}</button>
                                                    </div>
                                                    <!-- <img class="img-fluid" src="assets/img/pin-white.svg"> -->
                                                    <!-- <img class="img-fluid" src="assets/img/pin-green.svg"> -->
                                                    <!-- <a href="" title="Add to Multi Markets" class="add-pin">
                                                        <i class="mdi mdi-pin-outline"></i>
                                                    </a> -->
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <!-- sports -->

                                    <!-- racing html -->
                                    <app-guest-race-list *ngIf="mn.id == '7' || mn.id == '4339'" [list]="raceList"
                                        [id]="mn.id"></app-guest-race-list>
                                    <!-- racing html -->

                                    <app-casino *ngIf="mn.id == '99999'"></app-casino>
                                    <app-i-casino *ngIf="mn.id == '99995'"></app-i-casino>

                                    <div
                                        *ngIf="mn?.tabData?.length == 0 && !showLoader && mn.id != '99999' && mn.id != '99995' && mn.id != '7' && mn.id != '4339'">
                                        No data found</div>

                                    <app-casino-banner *ngIf="mn.id != '99999' && mn.id != '99995'"></app-casino-banner>
                                </tab>
                                <app-loader class="no-overlay" *ngIf="showLoader"></app-loader>
                            </tabset>

                            <!-- <app-casino-banner></app-casino-banner> -->
                            <!-- <ul class="nav nav-pills navtab-bg desktop-nav-pills">
                                    <li class="nav-item">
                                        <a href="#Cricket" data-bs-toggle="tab" aria-expanded="false"
                                            class="nav-link active">
                                            Cricket
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#Soccer" data-bs-toggle="tab" aria-expanded="true" class="nav-link">
                                            Soccer
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#Tennis" data-bs-toggle="tab" aria-expanded="false" class="nav-link">
                                            Tennis
                                        </a>
                                    </li>
                                </ul> -->

                            <!-- <div class="tab-content">
                                <div class="tab-pane show active" id="Cricket">
                                    <div class="row oneX2">
                                        <div class="col-md-6">
                                        </div>
                                        <div class="col-md-6 px-lg-0">
                                            <div class="oddsEventlist">
                                                <div class="btn-group">
                                                    <span>1</span>
                                                </div>
                                                <div class="btn-group">
                                                    <span>X</span>
                                                </div>
                                                <div class="btn-group">
                                                    <span>2</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row align-items-center row-my">
                                        <div class="col-md-5 px-1 col-10">
                                            <p class="matchname">
                                                <a>Lahore Qalandars v Peshawar</a>
                                                <span>11-02-2022 03:30</span>
                                            </p>
                                        </div>
                                        <div class="col-md-1 px-lg-0 text-center col-1">
                                            <span class="game-fancy mr-1">F</span>
                                        </div>
                                        <div class="col-md-6 px-0 col-1">
                                            <div class="oddsEventlist">
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <a href="" title="Add to Multi Markets" class="add-pin">
                                                    <i class="mdi mdi-pin-outline"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-center row-my">
                                        <div class="col-md-5 px-1 col-10">
                                            <p class="matchname">
                                                <a>Lahore Qalandars v Peshawar</a>
                                                <span>11-02-2022 03:30</span>
                                            </p>
                                        </div>
                                        <div class="col-md-1 px-lg-0 text-center col-1">
                                            <span class="game-fancy mr-1">F</span>
                                        </div>
                                        <div class="col-md-6 px-0 col-1">
                                            <div class="oddsEventlist">
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <a href="" title="Add to Multi Markets" class="add-pin">
                                                    <i class="mdi mdi-pin-outline"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-center row-my">
                                        <div class="col-md-5 px-1 col-10">
                                            <p class="matchname">
                                                <a>Lahore Qalandars v Peshawar</a>
                                                <span>11-02-2022 03:30</span>
                                            </p>
                                        </div>
                                        <div class="col-md-1 px-lg-0 text-center col-1">
                                            <span class="game-fancy mr-1">F</span>
                                        </div>
                                        <div class="col-md-6 px-0 col-1">
                                            <div class="oddsEventlist">
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <a href="" title="Add to Multi Markets" class="add-pin">
                                                    <i class="mdi mdi-pin-outline"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-center row-my">
                                        <div class="col-md-5 px-1 col-10">
                                            <p class="matchname">
                                                <a>Lahore Qalandars v Peshawar</a>
                                                <span>11-02-2022 03:30</span>
                                            </p>
                                        </div>
                                        <div class="col-md-1 px-lg-0 text-center col-1">
                                            <span class="game-fancy mr-1">F</span>
                                        </div>
                                        <div class="col-md-6 px-0 col-1">
                                            <div class="oddsEventlist">
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <div class="btn-group">
                                                    <button class="back">0.00</button>
                                                    <button class="lay">0.00</button>
                                                </div>
                                                <a href="" title="Add to Multi Markets" class="add-pin">
                                                    <i class="mdi mdi-pin-outline"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" id="Soccer">
                                    soccer here
                                </div>
                                <div class="tab-pane" id="Tennis">
                                    tennis here
                                </div>
                            </div> -->

                        </div>
                    </div>
                </div>
                <!-- eventlist -->
            </div>
        </div> <!-- end card-->

        <!-- inner footer -->
        <div class="row">
            <div class="col-md-12">
                <div class="inner-footer">
                    <div class="support-wrap">
                        <dl class="support-mail">
                            <a class="rules-btn-home">Privacy Policy</a>
                            <a class="rules-btn-home arrow">KYC</a>
                            <a class="rules-btn-home arrow">Terms and Conditions</a>
                            <a class="rules-btn-home arrow">Rules and Regulations</a>
                            <a class="rules-btn-home arrow">Responsible Gambling</a>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <!-- inner footer -->

    </div> <!-- end col -->

    <div class="col-md-3">
        <div class="openBets">
            <div class="collapse" id="collapseSetting">
                <app-stakes></app-stakes>
            </div>

            <h2>open bets</h2>
            <!-- <app-bet-list></app-bet-list> -->
        </div> <!-- end card-->
    </div> <!-- end col -->

</div>